/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { FC } from 'react';

import NewUi from '../../components/new-ui';

const withNewUI =
	(Component: FC): FC =>
	() =>
		(
			<NewUi>
				<Component />
			</NewUi>
		);

export default withNewUI;
